import React, { Fragment, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Calendar, Views, DateLocalizer } from 'react-big-calendar'
import styles from 'react-big-calendar/lib/css/react-big-calendar.css'
import events from './events'
import moment from 'moment'
import ResponsiveAppBar from './appbar'
import AddEventButton from './modalForm'

function Event({ event }) {
    return (
        <span>
            <strong>{event.title}</strong>
            {event.desc && ':  ' + event.desc}
        </span>
    )
}
Event.propTypes = {
    event: PropTypes.object,
}

function EventAgenda({ event }) {
    return (
        <span>
            <em style={{ color: 'magenta' }}>{event.title}</em>
            <p>{event.desc}</p>
        </span>
    )
}
EventAgenda.propTypes = {
    event: PropTypes.object,
}

let exceptions: Array<{ start: Date, end: Date, type: string }> = [
    {
        start: new Date("12/22/2025"),
        end: new Date("12/24/2025"),
        type: "on"
    },
    {
        start: new Date("12/31/2025"),
        end: new Date("1/2/2026"),
        type: "off"
    }
    ,
    {
        start: new Date("3/29/2026"),
        end: new Date("3/30/2026"),
        type: "off"
    }
    ,
    {
        start: new Date("4/1/2026"),
        end: new Date("4/3/2026"),
        type: "off"
    }
    ,
    {
        start: new Date("11/26/2025"),
        end: new Date("11/28/2025"),
        type: "off"
    },
    {
        start: new Date("6/17/2027"),
        end: new Date("11/28/2029"),
        type: "oor"
    },
    {
        start: new Date("6/17/2022"),
        end: new Date("8/22/2025"),
        type: "oor"
    },
    {
        start: new Date("6/17/2026"),
        end: new Date("6/19/2026"),
        type: "off"
    },
    {
        start: new Date("8/22/2025"),
        end: new Date("8/23/2025"),
        type: "on"
    },
    {
        start: new Date("6/19/2026"),
        end: new Date("6/26/2026"),
        type: "on"
    },
    {
        start: new Date("6/27/2026"),
        end: new Date("7/12/2026"),
        type: "off"
    },
    {
        start: new Date("7/12/2026"),
        end: new Date("7/27/2026"),
        type: "on"
    },
    {
        start: new Date("7/27/2026"),
        end: new Date("8/1/2026"),
        type: "off"
    },
    {
        start: new Date("8/1/2026"),
        end: new Date("8/7/2026"),
        type: "on"
    },
    {
        start: new Date("8/7/2026"),
        end: new Date("8/15/2026"),
        type: "off"
    },
    {
        start: new Date("8/15/2026"),
        end: new Date("8/21/2026"),
        type: "on"
    }
]

const customDayPropGetter = (date) => {
    let border = ""
    if (date.toDateString() == (new Date().toDateString()))
        border = "4px solid green"
    let dayOfWeek = moment(date).day()
    let ret = {

        className: "off",
        style: {

            border
        },

    };
    if (dayOfWeek === 3)
        ret = {
            className: "intro",
            style: {

                border
            },
        }
    else if (dayOfWeek === 4)
        ret = {
            className: "on",
            style: {

                border
            },
        }
    else if (dayOfWeek === 5) {

        let myDob = moment("29/8/2025", "DD/MM/YYYY");
        let today = moment(date);
        let diff = today.diff(myDob, "days");

        if (diff % 14 == 0)
            ret = {
                className: "on",
                style: {

                    border
                },
            }
        else
            ret = {
                className: "outro",
                style: {
                    border
                },
            }
    }
    else if (dayOfWeek === 6) {

        let myDob = moment("30/8/2025", "DD/MM/YYYY");
        let today = moment(date);
        let diff = today.diff(myDob, "days");

        if (diff % 14 == 0)
            ret = {
                className: "on",
                style: {
                    border
                },
            }
    }
    else if (dayOfWeek === 0) {

        let myDob = moment("31/8/2025", "DD/MM/YYYY");
        let today = moment(date);
        let diff = today.diff(myDob, "days");

        if (diff % 14 == 0)
            ret = {
                className: "on",
                style: {
                    border
                },
            }
    }
    else if (dayOfWeek === 1) {

        let myDob = moment("1/9/2025", "DD/MM/YYYY");
        let today = moment(date);
        let diff = today.diff(myDob, "days");

        if (diff % 14 == 0)
            ret = {
                className: "outro",
                style: {
                    border
                },
            }
    }

    for (let exception of exceptions) {
        if (exception.type == 'on') {

            if (date.getTime() == exception.start.getTime()) {
                if (ret.className == 'outro')
                    ret.className = 'on'
                if (ret.className == 'off')
                    ret.className = 'intro'
            }
            if (date.getTime() == exception.end.getTime()) {
                if (ret.className == 'intro')
                    ret.className = 'on'
                if (ret.className == 'off')
                    ret.className = 'outro'
            }
            if (date.getTime() > exception.start.getTime() && date.getTime() < exception.end.getTime()) {

                ret.className = 'on'

            }
        }
        if (exception.type == 'off') {

            if (date.getTime() == exception.start.getTime()) {
                if (ret.className == 'intro')
                    ret.className = 'off'
                if (ret.className == 'on')
                    ret.className = 'outro'
            }
            if (date.getTime() == exception.end.getTime()) {
                if (ret.className == 'on')
                    ret.className = 'intro'
                if (ret.className == 'outro')
                    ret.className = 'off'
            }
            if (date.getTime() > exception.start.getTime() && date.getTime() < exception.end.getTime()) {

                ret.className = 'of'

            }
        }
        if (exception.type == 'oor') {


            if (date.getTime() > exception.start.getTime() && date.getTime() < exception.end.getTime()) {

                ret.className = 'oor'

            }
        }

    }

    for (let event of events) {
        if (event.title == "No School" || event.title == "Early Release") {

            if (ret.className == "on" || ret.className == "outro")
                if (event.start.getTime() == date.getTime())
                    ret.style.border = "4px solid red"
            if (ret.className == "intro")
                if (event.start.getTime() == date.getTime())
                    ret.style.border = "4px solid green"
        }

    }

    if (date < new Date(Date.now() - 86400000))
        ret.style.opacity = 0.1

    return ret;
}

const customSlotPropGetter = (date) => {
    if (date.getDate() === 7 || date.getDate() === 15)
        return {
            className: "test",
        }
    else return {}
}

export default function Rendering({ localizer, setupDate }) {
    let [view, setView] = useState(Views.MONTH)
    let [date, setDate] = useState(new Date(setupDate))
    const { components, defaultDate } = useMemo(
        () => ({
            components: {
                agenda: {
                    event: EventAgenda,
                },
                event: Event,
            },
            defaultDate: new Date(),
        }),
        []
    )

    return <Calendar

        date={date}
        onNavigate={(e => setDate(e))}

        components={components}
        dayPropGetter={customDayPropGetter}
        defaultDate={defaultDate}
        defaultView={Views.MONTH}
        events={events} //events
        localizer={localizer}
        slotPropGetter={customSlotPropGetter}

    />



}
Rendering.propTypes = {
    localizer: PropTypes.instanceOf(DateLocalizer),
}